const CustomResourceApplyBDZB = () => import('@/views/main/report/customResourceApply/CustomResourceApplyBDZB.vue')
export default {
  path: '/main/report/customResourceApplyBDZB',
  name: 'customResourceApplyBDZB',
  component: CustomResourceApplyBDZB,
  children: []
}
